// extracted by mini-css-extract-plugin
export default {"gfas_fall_chart":"Hyeto_gfas_fall_chart__pRDyG"};